// ABOUTME: Component to display key evidence patterns in a formatted box
// ABOUTME: Used within the verdict section to show main evidence themes

import React from 'react';

interface KeyEvidencePatternsProps {
  patterns: string[] | string;
  className?: string;
}

export const KeyEvidencePatterns: React.FC<KeyEvidencePatternsProps> = ({
  patterns,
  className = ''
}) => {
  return (
    <div className={`bg-white/50 rounded-lg p-4 ${className}`}>
      <h3 className="font-semibold text-gray-800 mb-3">
        Key Evidence Patterns
      </h3>
      {Array.isArray(patterns) ? (
        <ul className="space-y-2">
          {patterns.map((pattern, idx) => (
            <li key={idx} className="flex items-start gap-2">
              <span className="text-blue-500 mt-1">•</span>
              <span className="text-gray-600 text-sm">{pattern}</span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-600 text-sm">{patterns}</p>
      )}
    </div>
  );
};
